import { createFileRoute } from "@tanstack/react-router"
import ArchivedPurchaseOrdersTab from "~/components/purchaseOrder/tabs/ArchivedPurchaseOrdersTab"
import { WorkspacePage } from "~/components/design-system/pages"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/_layout/archived")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Orders - Archived")
  return (
    <WorkspacePage fillContent contentClassName="p-0">
      <ArchivedPurchaseOrdersTab />
    </WorkspacePage>
  )
}
